import type { EnemyConfig } from '../../entities/EnemyConfig';

export const RABBIT_CONFIG: EnemyConfig = {
  id: 'rabbit',
  displayName: 'Заяц',
  maxHp: 1,
  speed: 0,
  movementBehavior: 'jump',
  movementParams: {
    jumpDistanceX: 80,
    jumpYRange: 50,
    jumpDurationMs: 500,
    cooldownMs: 200,
    arcHeight: 30,
  },
  size: 20,
  color: 0xc2a878,
  scoreReward: 5,
};
